jQuery(document).ready(function ($) {

    if (!Modernizr.svg) {
        //SVG's vervangen door PNG-variant in het geval van geen ondersteuning van SVG's
        $('.block-system-branding-block .site-logo img').attr('src', '/themes/ef2_custom/img/logo.png');
    }

	$('#block-views-block-merken-overzicht-block-1 .view-merken-overzicht .owl-carousel').owlCarousel({
        items: 5,
        center: true,
	    loop:true,
	    margin:10,
	    nav:false,
	    autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:5
            }
        }
	});

    $('.view-nieuws-slider .owl-carousel').owlCarousel({
        items: 1,
        loop:true,
        margin:100,
        nav:true,
        dots:true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        animateOut: 'fadeOut',
        navText: [
          "<div class='icon-arrow prev'></div>",
          "<div class='icon-arrow next'></div>"
        ]
    });

    $('.view-home-over-ons .views-field-field-content-afbeelding .field-content').addClass('owl-carousel owl-theme').owlCarousel({
        items: 1,
        loop:true,
        nav:false,
        dots:true,
        autoplay: true,
        autoWidth: false,
        autoplayHoverPause: true,
        animateOut: 'fadeOut',
    });

	$('#menu-toggle').on('click touchstart', function(event){
        event.stopImmediatePropagation();
        event.preventDefault();
        $(this).toggleClass('active');
        $('#navbar').toggleClass('menu-open');
        $('body').toggleClass('main-menu-active');
        $('#block-categorie-navigatie ul.menu li').removeClass('active');
        $('#block-zoekveld').removeClass('active');
    });


    $('.icon-search').on('click touchstart', function(event){
        event.stopImmediatePropagation();
        event.preventDefault();
        $('#block-zoekveld').toggleClass('active');
        $('#navbar').toggleClass('menu-open');
        $('body').toggleClass('main-menu-active');
        $('ul.menu li').removeClass('active');
        $('#block-zoekveld input[type="search"]').get(0).focus();
        // Keyboard.show();
    });

    $('#search-toggle').on('click touchstart', function(event){
        event.stopImmediatePropagation();
        event.preventDefault();
        $('#block-zoekveld').toggleClass('active');
        $('#block-zoekveld input[type="search"]').get(0).focus();
        // Keyboard.show();
    });

    $('#block-menucontainer').outerHeight($('#block-menucontainer > .menu-wrapper').outerHeight());

    $('#block-categorie-navigatie ul.menu li.menu-item a').on('click touchstart', function(event){
        if($(this).parent('li.menu-item').find('ul.menu').length){
            $('#block-categorie-navigatie ul li.active').not($(this).parents('li.menu-item')).removeClass('active');
            $('#block-categorie-navigatie ul li.active, #block-categorie-navigatie ul li.menu-item--active-trail').not($(this).parents('li.menu-item')).toggleClass('old-active');
            // $('#block-categorie-navigatie ul li.active, #block-categorie-navigatie ul li.menu-item--active-trail').removeClass('menu-item--active-trail');
            $(this).closest('li.menu-item').toggleClass('active');

            if($(this).closest('li.menu-item.active').length > 0){
                $('body').addClass('sub-menu-item-active');
            }else{
                $('body').removeClass('sub-menu-item-active');
            }
            
            event.preventDefault();
            event.stopPropagation();
        }
    });

    $(document).keydown(function(e){
        if (e.keyCode == 27) {
            $('#navbar').toggleClass('menu-open');
            $('body').toggleClass('main-menu-active'); 
            $('body').removeClass('sub-menu-item-active');       
            $('#block-categorie-navigatie ul.menu li').removeClass('active');
            $('#block-categorie-navigatie ul.menu li').removeClass('old-active');
            $('#menu-toggle').removeClass('active');
            $('#block-zoekveld').removeClass('active');
        }
    });
    
    $('body').on('click touchstart', function(event){
        if (!$(event.target).closest('#navbar').length) {
            $('#navbar').removeClass('menu-open');
            $('body').removeClass('main-menu-active');
            $('body').removeClass('sub-menu-item-active');
            $('#block-categorie-navigatie ul.menu li').removeClass('active');
            $('#block-categorie-navigatie ul.menu li').removeClass('old-active');
            $('#menu-toggle').removeClass('active');
            $('#block-zoekveld').removeClass('active');
        }
    });

    $('#block-categoriemenu .ruit').outerHeight($('#block-categoriemenu > .menu-wrapper').outerHeight());

    $('#block-categoriemenu .submenu-wrapper .submenu-item-content > ul.menu > li.menu-item > a').on('click touchstart', function(event){
        if($(this).parent('li.menu-item').find('ul.menu').length){
            $('#block-categoriemenu ul li.active').not($(this).parents('li.menu-item')).removeClass('active');
            $('#block-categoriemenu > ul > li.active, .block-categoriemenu > ul > li.menu-item--active-trail').not($(this).parents('li.menu-item')).toggleClass('old-active');
            $(this).closest('li.menu-item').toggleClass('active');
            event.preventDefault();
            event.stopPropagation();
        }
    });

    $('#block-views-block-uitklapblokken-block-1 .view-content .toggle-box .title').on('click touchstart', function(event){
        event.stopImmediatePropagation();
        event.preventDefault();
        $('#block-views-block-uitklapblokken-block-1 .view-content .toggle-box').not( $(this).parent() ).removeClass('open');
        $(this).parent().toggleClass('open');
    });


    $('#navbar #block-categorie-navigatie ul.menu li .submenu-wrapper .menu-back-link').on('click touchstart', function(event){      
        $(this).closest('li.menu-item--expanded').removeClass('active');
        event.preventDefault();
        event.stopPropagation();
    });


    // Details open when checked
    // $( document ).ajaxComplete(function() {
    //     if(jQuery("#block-views-block-nieuws-overzicht-2-block-1 .view-filters .form-type-checkbox input:checked").length) {                    
    //         jQuery("#block-views-block-nieuws-overzicht-2-block-1 .bef-exposed-form .form--inline > .form-item").prop("open", true);  // checked
    //         // jQuery("#block-views-block-projectoverzicht-block-1 .bef-exposed-form .form--inline > .form-item").addClass('open');  // checked
    //     }
    //     else {
    //         $("#block-views-block-nieuws-overzicht-2-block-1 .bef-exposed-form .form--inline > .form-item").removeClass('open');  // unchecked
    //     }
    // });

    // $('details').details();



});
